import { defineStore } from 'pinia'
import { Result } from '@/classes/Result'
import { ConversationMessage } from '@/classes'
import { getRandomString } from '~/utils/useRandom'

interface Toast {
  id?: string
  content: string
  description?: string
  message?: ConversationMessage
  type?: 'notification' | 'success' | 'failure'
  extra?: {
    [key: string]: any
  }
}

export default defineStore('toasts', () => {
	const items: Ref<Toast[]> = ref([])

	const add = (toast: Toast) => {
    items.value = [
      ...items.value,
      {
        ...toast, id: toast.id ?? getRandomString()
      }
    ]
  }

  const remove = (id: string) => {
    items.value = items.value.filter(t => t.id !== id)
  }

  const error = <T>(response: Result<T>) => {
    const title = response.ok ? '' : useNuxtApp().$i18n.t(`errors.${(response.error as any).message as any ?? response.error ?? 'error'}`)
      
    add({
      content: title ?? `Oops.`,
      description: response.error?.message, type: 'failure'
    })
    
    return response
  }

	return {
    add, remove, error, items
	}
})
